// Botón de refresh manual del inventario.
// Vive en el header, a la izquierda del AccountMenu. Indicadores:
//   - Icono "refresh-cw" minimalista. Gira durante una carga activa.
//   - Punto ámbar arriba a la derecha cuando el snapshot mostrado es
//     "stale" (proviene del cache IDB y hay revalidación silenciosa
//     en curso, o todavía no hubo confirmación remota tras un manual).
//   - Tooltip con la edad relativa de la última carga.

import { html } from 'htm/preact'
import { useEffect, useState } from 'preact/hooks'

import {
  refreshInventory,
  subscribeInventoryChange,
  getInventoryState
} from '../lib/inventory-store.js'

const REFRESH_ICON = html`
  <svg
    class="header__refresh-icon"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
`

function formatRelative(iso) {
  if (!iso) return null
  const ageMs = Date.now() - new Date(iso).getTime()
  if (ageMs < 60_000) return 'hace segundos'
  const minutes = Math.floor(ageMs / 60_000)
  if (minutes === 1) return 'hace 1 minuto'
  if (minutes < 60) return `hace ${minutes} min`
  const hours = Math.floor(minutes / 60)
  if (hours === 1) return 'hace 1 hora'
  if (hours < 24) return `hace ${hours} h`
  const days = Math.floor(hours / 24)
  return days === 1 ? 'hace 1 día' : `hace ${days} días`
}

export function RefreshButton() {
  const [inv, setInv] = useState(getInventoryState())
  // Tick periódico para refrescar la edad relativa del tooltip.
  const [, setTick] = useState(0)

  useEffect(() => {
    const unsub = subscribeInventoryChange(setInv)
    const t = window.setInterval(() => setTick((x) => x + 1), 30_000)
    return () => {
      unsub()
      window.clearInterval(t)
    }
  }, [])

  const isLoading = inv.state === 'loading'
  const isSpinning = isLoading || inv.stale
  const relative = formatRelative(inv.scannedAt)

  const title = isLoading
    ? 'Sincronizando con SharePoint…'
    : relative
      ? `Refrescar inventario desde SharePoint (última carga: ${relative})`
      : 'Refrescar inventario desde SharePoint'

  const handleClick = () => {
    refreshInventory().catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('[RefreshButton] refresh falló:', err)
    })
  }

  return html`
    <button
      type="button"
      class=${`header__refresh ${isSpinning ? 'header__refresh--spinning' : ''}`}
      onClick=${handleClick}
      disabled=${isLoading && !inv.data}
      title=${title}
      aria-label=${title}
    >
      ${REFRESH_ICON}
      ${inv.stale
        ? html`<span class="header__refresh-dot" aria-hidden="true"></span>`
        : null}
    </button>
  `
}
